import { render, staticRenderFns } from "./ChatbotMenu.vue?vue&type=template&id=3af43994"
import script from "./ChatbotMenu.vue?vue&type=script&lang=js"
export * from "./ChatbotMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports